<template>
        
        <v-row 
            no-gutters
            class="background-submenu"
        >
            <v-col>

                <v-list>

                    <div class="title-submenu">
                      {{ $t('films') }}
                    </div>

                    <v-list-item
                        link
                        tile
                        :to="`/${$i18n.locale}/consumibles/film-estirable-automatic`"
                    >
                        <!-- :to="`${rutas[0].path}`" -->
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('filmAutomatic') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/film-estirable-manual`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('filmManual') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/films-preestirats`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('filmPreestirat') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/lamina-polietile-PE`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('Lamina') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cobre-palets`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cubrepalets') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/funda-palet`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('fundapalets') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/bandita`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('bandita') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
<!-- //////////////////////////// -->
            <v-col>
                <v-list>

                    <div class="title-submenu">
                      {{ $t('precintes') }}
                    </div>

                    <v-list-item
                        link
                        tile
                        :to="`/${$i18n.locale}/consumibles/cintes-adhesives`"
                    >
                        <!-- :to="`${rutas[0].path}`" -->
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <!-- <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon> -->
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cintesAdhesives') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cintes-adhesives-impreses`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cintesAdhesivesImpreses') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cintes-creppe`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cintesCreppe') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cintes-tramades`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cintesTramades') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/precintes-seguretat`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('precintesSeguretat') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/flejes`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('flejes') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cintes-ribbon`"
                        
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cintesRibbon') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                </v-list>
            </v-col>

            <v-col>

                <v-list>

                    <div class="title-submenu">
                        {{ $t('consumibles') }}
                    </div>

                    <v-list-item
                        link
                        tile
                        :to="`/${$i18n.locale}/consumibles/bosses-aire`"
                        
                    >
                        <!-- :to="`${rutas[0].path}`" -->
                        <v-icon size="15" class="icon-submenu"  color="#df7606">mdi-rhombus-medium</v-icon>
                        <!-- <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon> -->
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('bossesAire') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cartro-ondulat`"
                    >
                        <v-icon size="15" class="icon-submenu"  color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cartroOndulat') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/plastic-bombolla`"
                    >
                        <v-icon size="15" class="icon-submenu"  color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('plasticBombolla') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/bobines-foam`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('BobinesFoam') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cantoneres-foam`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cantoneresFoam') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/bosses-mini-grip`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('bossesMinigrip') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/sobres-paper-bombolla`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('sobresBombolla') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/etiquetes-adhesives`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('etiquetesAdhesives') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/etiquetes-adr`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('etiquetesAdr') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/cantoneres-cartro`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('cantoneresCartro') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/paper-kraft`"
                    >
                        <v-icon size="15" class="icon-submenu" color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('paperKraft') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item 
                        link 
                        tile
                        :to="`/${$i18n.locale}/consumibles/farciment-porex`"
                    >
                        <v-icon size="15" class="icon-submenu"  color="#df7606">mdi-rhombus-medium</v-icon>
                        <v-list-item-content> 
                            <v-list-item-title class="subtitle-2 pl-5 m-0">
                                {{ $t('farcimentPorex') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            
            </v-col>
        </v-row>

</template>

 <!--  <v-row no-gutters
    class="background-submenu">

    <v-col>
      <v-list>

        <div class="title-submenu" v-if="menu.children2">
          {{ menu.children[0].title }}
        </div>

        <v-list-item link tile
          v-for="(submenu, index) in menu.children" :key="index" 
            :to="submenu.path">
    
            <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>
                 
            </v-btn>
            <v-list-item-content> 
              <v-list-item-title class="subtitle-2 pl-5 m-0">
                  {{ $t('enfardadores') }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    
    </v-col>
  </v-row> -->
    <!--    
        <v-menu
            transition="slide-y-transition"
            bottom
            color="white"
            open-on-hover offset-y
        >
            <template v-slot:activator="{ on }">
                <v-btn
                    color="white"
                    v-on="on"
                    class="menu-principal--with-children"
                    text
                    :to="`${rutas[0].path}`"
                > 
                
            </template>
        </v-menu> 
    -->

<script>

// import IconBase from '@/components/elements/IconBase.vue'
// import arrowDown from '@/assets/svg/arrowDown.vue'

export default {
    name: 'SubmenuConsumibles',
    data() {
    return {   
        submenu1: [
            "films",
            "filmAutomatic",
            "filmManual",
            "filmPreestirat",
            "Lamina",
            "cubrepalets",
            "fundapalets",
            "bandita",
            ]
        }
    },
    components: {
        // IconBase,
        // arrowDown,
    },
    methods: {
        triggerClick: function (route){
        this.$router.push(route);
        }
    },
    computed: {
        rutas () {
            return this.$router.options.routes;
        },
        menu () {
            return this.$store.state.menu
        }
    }
    
}
</script>


<style scoped lang="scss">

.background-submenu {
    background: white;
    border-radius: 0 !important;
}

.icon-submenu {
    margin-right: -15px !important;
    padding-right: 0 !important;
    width: 15px !important;
}

/* .column-menu {
    flex-flow: column wrap !important;
    font-size: .65em;
    width: max-content;
    min-width: auto;
    position: absolute;
    background: white;
    padding-top: 20px;
    padding-bottom: 40px;
    border-radius: 0 0 22px 10px;
    border:0;
    border-top: 5px solid rgb(92, 130, 253);
    background-image: linear-gradient(#c8e0fc, #c7fcf2);

    li {
      padding: 10px 25px 0px 0px;

      div {
        border-bottom: 3px solid transparent;
        padding: 6px 10px 4px;
        border-radius: 4px;
      }
      div:hover {
        color: rgb(60, 137, 253);
        cursor: pointer;
        background-color: rgb(255, 255, 255);
      }
    }
} */

</style>